import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatDate, formatMoney, callGameServerApi } from '../Helpers';
import chess_pieces from '../assets/chess_pieces.png';
import cards_row from '../assets/cards_row.png';
import logo_wide from '../assets/logo_wide.png';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import OneUser from '../ones/OneUser';
import OneLeagueStage from '../ones/OneLeagueStage';
import { GAME_TYPES } from '../Constants';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ error, setError ] = useState(false);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ isUserInLeague, setIsUserInLeague ] = useState(false);

  const [ leagueId, setLeagueId ] = useState(props.leagueId);
  const [ leagueData, setLeagueData ] = useState(null);


  const init = async () => {
    appContext.changeOrientation(requiredOrientation);

    setLoading(true);
    await  getLeagueData().then((response) => {
      if(response.status === 1) {
        setLeagueData(response.data)
        setLoading(false);
        setReady(true);
      } else {
        appContext.tellError(response.msg)
      }

    })

  }

  const getLeagueData = () => {
    return new Promise( async resolve => {
      setError(false);
      await callGameServerApi('get-league-data', { leagueId }).then(response => resolve(response))
    })
  }

  const joinLeague = async () => {
    setLoading(true);
    await callGameServerApi('join-league', { leagueId }).then(response => {
      setLoading(false);
      if(response.status === 1) {
        appContext.tellMessage('You joined this league successfully');
        getLeagueData().then((response) => {
          if(response.status === 1) {
            setLeagueData(response.data)
            
          } else {
            appContext.tellError(response.msg)
          }
    
        })
        
      } else {
        getLeagueData(); //just refresher
        appContext.tellError(response.msg);
      }
    });
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();

    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  useEffect(() => {
    setLeagueId(props.leagueId);
  }, [ props.leagueId ]);

  useEffect(() => {
    init();
  }, [ leagueId ]);

  useEffect(() => {
    if(leagueData) {
      let _isUserInLeague = false;
      JSON.parse(leagueData.participants).forEach((item, i) => {
        if(appContext.auth && appContext.userData && appContext.userData.id === item.id) {
          _isUserInLeague = true;
        }
      });
      setIsUserInLeague(_isUserInLeague);
    }
  }, [ leagueData ]);

  if(ready && leagueData) {
    return (
      <>
        <TopBar title="League"/>
        <div className='FullPane' data-support-top-bar={true}>
          <div className="mNoMargin mNoPad mLeagueBanner" style={{ overflow: "hidden" }}>
            <img
              className="mImg"
              src={(leagueData.gameType === GAME_TYPES.ARUBASTINI || leagueData.gameType === GAME_TYPES.LASTCARD) ? cards_row : chess_pieces }
            />

            <div className="mCover">
              <div className='container'>
                <p className="mTitle font-light" style={{ fontSize: "30px" }}>{leagueData.title}</p>
              </div>
            </div>

          </div>
          <div className='container' style={{ paddingBottom: "var(--topBarheight)" }}>
            {
              (leagueData) ?
              <div className='row'>
                <div className='col-12' style={{ marginTop: "20px" }}>

                  <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                    League ID: &nbsp;<span className='text-light font-regular' style={{ fontSize: "25px" }}>{leagueData.uid}</span>
                  </h6>
                  <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                    Number of Participants: &nbsp;<span className='text-light font-regular' style={{ fontSize: "15px" }}>{leagueData.noParticipants}</span>
                  </h6>
                  <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                    Winner Award: &nbsp;<span className='text-light font-regular' style={{ fontSize: "15px" }}>{formatMoney(leagueData.awardInTsh)} Tsh</span>
                  </h6>
                  <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                    Entrance Fee: &nbsp;<span className='text-light font-regular' style={{ fontSize: "15px" }}>{leagueData.entranceFee} Coins</span>
                  </h6>
                  <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                    Status: &nbsp;
                    <span className='text-goldish font-light'>
                      {
                        (leagueData.status === 'hosted') ?
                        "Waiting for players to join..."
                        :
                        (leagueData.status === 'started') ?
                        "Ongoing"
                        :
                        leagueData.status
                      }
                    </span>
                  </h6>

                  <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                    Created on: &nbsp;<span className='text-goldish font-light'>{formatDate(leagueData.announcedDate)}</span>
                  </h6>
                  {
                    (leagueData.status !== 'terminated') ?
                    <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                      Starts (ed) on: &nbsp;<span className='text-goldish font-light'>{formatDate(leagueData.startDate)}</span>
                    </h6> : ""
                  }

                  {
                    (leagueData.status === 'completed') ?
                    <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                      Ended on: &nbsp;<span className='text-goldish font-light'>{formatDate(leagueData.endDate)}</span>
                    </h6> : ""
                  }

                  {
                    (leagueData.winnerInfo) ?
                    <h6 style={{ fontSize:"14px" }} className='text-muted mOneLineText'>
                      Winner: &nbsp;<OneUser id={leagueData.winnerInfo.id} username={leagueData.winnerInfo.username} simple={true}/>
                    </h6> : ""
                  }
                  
                </div>
                {
                  (leagueData.noParticipants > JSON.parse(leagueData.participants).length && !isUserInLeague) ?
                  <div className='col-12' style={{ marginTop: "20px" }}>
                    <button
                      onClick={() => {
                        appContext.activateDialog({
                          message: `This League costs ${leagueData.entranceFee} coins to join, Do you want to join?`,
                          onConfirm: joinLeague,
                        })
                      }}
                      className="btn btn-rounded btn-block bg-goldish">
                      Join This League
                    </button>
                  </div> : ""
                }
                <div className='col-12' style={{ marginTop: "20px" }}>
                  <h5 className='text-muted'>Enrolled Participants ({JSON.parse(leagueData.participants).length})</h5>
                  {
                    (JSON.parse(leagueData.participants).length > 0) ?
                    JSON.parse(leagueData.participants).map((item, i) => {
                      return <OneUser id={item.id} username={item.username} key={i}/>
                    }):
                    <div className='text-start'>
                      <small className='font-light'>No participants were found</small>
                    </div>
                  }
                </div>

                <div className='col-12' style={{ marginTop: "40px" }}>
                  <h5 className='text-muted'>League Timeline - {leagueData.noStages} Stage(s)</h5>
                  {
                    (JSON.parse(leagueData.stages).length > 0) ?
                    JSON.parse(leagueData.stages).map((item, i) => {
                      return <OneLeagueStage stage={item} stageNo={i+1} key={i}/>
                    }):
                    <div className='text-start'>
                      <small className='font-light'>Stages and matches will be shown here at {formatDate(leagueData.startDate)}</small>
                    </div>
                  }


                </div>

              </div>:
              <div className='row'>

                <div className='col-6'>
                  <img src={chess_pieces} style={{ width: "100%", height: "auto" }}/>
                </div>
                <div className='col-6'>
                  <img src={cards_row} style={{ width: "100%", height: "auto" }}/>
                </div>

              </div>
            }
          </div>
        </div>


      </>
    )
  } else {
    return <></>;
  }
}
